import { Button, Chip, CircularProgress, Grid } from "@mui/material";
import InvoiceForm from "./InvoiceForm";
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { useEffect, useState } from "react";
import { error400Handler, error422Handler, request } from "@/Api";
import { setError } from "@/nav/navSlice";
import { useDispatch } from "react-redux";
import { json, useNavigate, useSearchParams } from "react-router-dom";
import { parseJwt } from "@/auth/authUtils";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import NumbersRoundedIcon from '@mui/icons-material/NumbersRounded';

export default function InvoicePortalInvoicePage(){
    const navigate = useNavigate()
    const [ searchParams, _ ] = useSearchParams()
    const [ invoice, setInvoice ] = useState({})
    const [ formData, setFormData ] = useState(null)
    const [ uploading, setUploading ] = useState(false)
    const [ errors, setErrors ] = useState({})

    const noInvoiceData = Object.keys(invoice).length == 0

    const token = searchParams.get("token")
    const tokenInfo = parseJwt(token)

    const overrides = token ? {
        docket: tokenInfo.docket,
        vendor_email: tokenInfo.vendor_email
    } : {}

    const dispatch = useDispatch()
    const onSubmit = () => {
        setUploading(true)
        const invoiceData = {...invoice}
        formData.append("accounting_bill", JSON.stringify(invoiceData))
        console.log("SUMBUT")
        request.post("/accounting-bills", formData, {headers: {"Content-Type": "multipart/form-data"}, params: {schema: "organization_1"}})
        .then(response=>{
            setInvoice({})
            navigate("/ap/invoice-thank-you")
        })
        .catch(error=>{
            error422Handler(error, (parsedError) => {
                dispatch(setError({message: "Your invoice has errors, please check the form."}))
                setErrors(parsedError)
            })
            error400Handler(error, (parsedError) => {
                dispatch(setError({message: parsedError}))  
            })
        })
        .finally(()=>{
            setUploading(false)
        })
    }
    const handleFormDataTransfer = (formData) => {
        setFormData(formData)
    }
    return (
        <Grid container justifyContent={"center"} paddingTop={10}>
            <Grid item width={"80%"} minWidth={800} paddingBottom={10}>
                <div style={{textAlign: "center"}}>
                    <h1>Upload your invoice</h1>
                    {tokenInfo && 
                    <p>
                        {tokenInfo.name} has invited <Chip sx={{margin: 1, padding: 1}} icon={<EmailOutlinedIcon style={{color: "#4285F4"}}/>} label={tokenInfo.vendor_email}/> 
                        to invoice for project <Chip sx={{margin: 1, padding: 1}} icon={<NumbersRoundedIcon style={{color: "#27C77E"}}/>} label={tokenInfo.docket}/>.
                    </p>}
                </div>
                <InvoiceForm 
                    errors={errors}
                    setErrors={setErrors}
                    invoice={invoice}
                    setInvoice={setInvoice}
                    onFormDataTransfer={handleFormDataTransfer}
                    overrides={overrides}
                />
                <Grid container justifyContent={"space-between"} paddingTop={5}>
                    <Grid item fontSize={12} width={"50%"}>
                        Upon clicking "Submit", the invoice will be sent to the selected Makers Producer for processing.

                        Please note that Makers' standard payment terms are 30 days. After initiating payment, it can take a few days to reach your account.
                    </Grid>
                    <Grid item>
                        {uploading ? <CircularProgress /> :
                        <Button disabled={noInvoiceData} variant="contained" onClick={onSubmit} startIcon={<SendRoundedIcon />} >
                            Submit
                        </Button>}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}